import { connectionString } from '../components/dbNames';
import Socket from 'socket.io-client';

export const socket = Socket(connectionString);